import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Asynchronously loads the component for DataAndPrivacy
 *
 */
import Loadable from 'react-loadable';
import PageLoader from '@project/components/Loaders/PageLoader';
export default Loadable({
    loader: function () { return import(/* webpackChunkName: 'DataAndPrivacy' */ './index'); },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return _jsx(PageLoader, {});
    },
});
export var DeleteAccount = Loadable({
    loader: function () {
        return import(/* webpackChunkName: 'DeleteAccount' */ './AccountDelete');
    },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return _jsx(PageLoader, {});
    },
});
export var RequestData = Loadable({
    loader: function () { return import(/* webpackChunkName: 'RequestData' */ './RequestData'); },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return _jsx(PageLoader, {});
    },
});
export var PrivacyPolicyList = Loadable({
    loader: function () {
        return import(/* webpackChunkName: 'PrivacyPolicyList' */ './PrivacyPolicyList');
    },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return _jsx(PageLoader, {});
    },
});
